var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "panel-group", attrs: { gutter: 10 } },
    [
      _c(
        "el-col",
        { staticClass: "card-panel-col", attrs: { span: _vm.metricSpan() } },
        [
          _c(
            "div",
            {
              staticClass: "card-panel",
              on: {
                click: function ($event) {
                  return _vm.handleSetLineChartData("created")
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "card-panel-icon-wrapper icon-people" },
                [_c("i", { staticClass: "el-icon-tickets card-panel-icon" })]
              ),
              _c(
                "div",
                { staticClass: "card-panel-description" },
                [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v("Created"),
                  ]),
                  _c("count-to", {
                    staticClass: "card-panel-num",
                    attrs: {
                      "start-val": 0,
                      "end-val": _vm.metric("created"),
                      duration: 200,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-col",
        { staticClass: "card-panel-col", attrs: { span: _vm.metricSpan() } },
        [
          _c(
            "div",
            {
              staticClass: "card-panel",
              on: {
                click: function ($event) {
                  return _vm.handleSetLineChartData("assigned")
                },
              },
            },
            [
              _c("div", { staticClass: "card-panel-icon-wrapper icon-open" }, [
                _c("i", { staticClass: "el-icon-star-on card-panel-icon" }),
              ]),
              _c(
                "div",
                { staticClass: "card-panel-description" },
                [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v("Assigned"),
                  ]),
                  _c("count-to", {
                    staticClass: "card-panel-num",
                    attrs: {
                      "start-val": 0,
                      "end-val": _vm.metric("assigned"),
                      duration: 200,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-col",
        { staticClass: "card-panel-col", attrs: { span: _vm.metricSpan() } },
        [
          _c(
            "div",
            {
              staticClass: "card-panel",
              on: {
                click: function ($event) {
                  return _vm.handleSetLineChartData("unassigned")
                },
              },
            },
            [
              _c("div", { staticClass: "card-panel-icon-wrapper icon-money" }, [
                _c("i", { staticClass: "el-icon-star-off card-panel-icon" }),
              ]),
              _c(
                "div",
                { staticClass: "card-panel-description" },
                [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v("Un-Assigned"),
                  ]),
                  _c("count-to", {
                    staticClass: "card-panel-num",
                    attrs: {
                      "start-val": 0,
                      "end-val": _vm.metric("unassigned"),
                      duration: 200,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-col",
        { staticClass: "card-panel-col", attrs: { span: _vm.metricSpan() } },
        [
          _c(
            "div",
            {
              staticClass: "card-panel",
              on: {
                click: function ($event) {
                  return _vm.handleSetLineChartData("accepted")
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "card-panel-icon-wrapper icon-message" },
                [_c("i", { staticClass: "el-icon-document card-panel-icon" })]
              ),
              _c(
                "div",
                { staticClass: "card-panel-description" },
                [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v("Accepted"),
                  ]),
                  _c("count-to", {
                    staticClass: "card-panel-num",
                    attrs: {
                      "start-val": 0,
                      "end-val": _vm.metric("accepted"),
                      duration: 200,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-col",
        { staticClass: "card-panel-col", attrs: { span: _vm.metricSpan() } },
        [
          _c(
            "div",
            {
              staticClass: "card-panel",
              on: {
                click: function ($event) {
                  return _vm.handleSetLineChartData("processing")
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "card-panel-icon-wrapper icon-message" },
                [_c("i", { staticClass: "el-icon-edit card-panel-icon" })]
              ),
              _c(
                "div",
                { staticClass: "card-panel-description" },
                [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v("Processing"),
                  ]),
                  _c("count-to", {
                    staticClass: "card-panel-num",
                    attrs: {
                      "start-val": 0,
                      "end-val": _vm.metric("processing"),
                      duration: 200,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-col",
        { staticClass: "card-panel-col", attrs: { span: _vm.metricSpan() } },
        [
          _c(
            "div",
            {
              staticClass: "card-panel",
              on: {
                click: function ($event) {
                  return _vm.handleSetLineChartData("pendingFloorplan")
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "card-panel-icon-wrapper icon-shopping" },
                [_c("i", { staticClass: "el-icon-picture card-panel-icon" })]
              ),
              _c(
                "div",
                { staticClass: "card-panel-description" },
                [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v("Floorplan"),
                  ]),
                  _c("count-to", {
                    staticClass: "card-panel-num",
                    attrs: {
                      "start-val": 0,
                      "end-val": _vm.metric("pendingFloorplan"),
                      duration: 300,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-col",
        { staticClass: "card-panel-col", attrs: { span: _vm.metricSpan() } },
        [
          _c(
            "div",
            {
              staticClass: "card-panel",
              on: {
                click: function ($event) {
                  return _vm.handleSetLineChartData("qaPending")
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "card-panel-icon-wrapper icon-shopping" },
                [_c("i", { staticClass: "el-icon-check card-panel-icon" })]
              ),
              _c(
                "div",
                { staticClass: "card-panel-description" },
                [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v("QA Pending"),
                  ]),
                  _c("count-to", {
                    staticClass: "card-panel-num",
                    attrs: {
                      "start-val": 0,
                      "end-val": _vm.metric("qaPending"),
                      duration: 200,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-col",
        { staticClass: "card-panel-col", attrs: { span: _vm.metricSpan() } },
        [
          _c(
            "div",
            {
              staticClass: "card-panel",
              on: {
                click: function ($event) {
                  return _vm.handleSetLineChartData("all")
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "card-panel-icon-wrapper icon-message" },
                [_c("i", { staticClass: "el-icon-date card-panel-icon" })]
              ),
              _c(
                "div",
                { staticClass: "card-panel-description" },
                [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v("All"),
                  ]),
                  _c("count-to", {
                    staticClass: "card-panel-num",
                    attrs: {
                      "start-val": 0,
                      "end-val": _vm.metric("all"),
                      duration: 500,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }